export default "__VITE_ASSET__da6d6a4c__"